var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorarioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.11 31.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#004c7b;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 379") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23.13 22.54 16.05 15.68 16.05 5.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.5,26.29a15,15,0,0,0,18.88,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.62,24A15,15,0,0,0,26.71,5.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.1,15.69A15.1,15.1,0,0,0,19,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,1a15,15,0,0,0,3,29.7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorarioIcon);
export default __webpack_public_path__ + "static/media/HorarioIcon.d5162793be92074a0651a2bc6dc3cfd6.svg";
export { ForwardRef as ReactComponent };